<template>
  <v-flex xs12>
    <v-layout row align-center justify-space-between>
        <v-flex xs3 v-if="hasPermission(scp.WorkOrder.clientCode)">
          <v-icon @click="setNewDate()" small color="primary">calendar_today</v-icon>
          <v-icon @click="prevDay()" small color="primary">chevron_left</v-icon>
        </v-flex>
        <v-flex xs12 class="text-xs-center caption" v-if="!hasPermission(scp.WorkOrder.clientCode)">
            {{scp.WorkOrder.clientCode}}: {{varietalAbbreviation}} - {{vineyardAbbreviation}} - {{scp.estimatedTons}}T
            <!-- <div v-if="scp.WorkOrder.Reservations[0]">{{scp.WorkOrder.Reservations[0].Asset.NAME}}</div> -->
        </v-flex>
        <v-flex xs9 class="text-xs-center caption" @click="goto()" v-else>
            {{scp.WorkOrder.clientCode}}: {{varietalAbbreviation}} - {{vineyardAbbreviation}} - {{scp.estimatedTons}}T
            <div v-for="(item, index) in scp.WorkOrder.Reservations">
              <span v-if="index==0">[ </span>{{item.Asset.NAME}}
              <span v-if="index==scp.WorkOrder.Reservations.length-1"> ]</span>
            </div>
        </v-flex>
        <v-flex xs1 v-if="hasPermission(scp.WorkOrder.clientCode)">
            <v-icon @click="nextDay()" small color="primary">chevron_right</v-icon>
        </v-flex>
    </v-layout>
    </v-flex>
</template>

<script>

import moment from 'moment'
import axios from 'axios'
import myMixins from '../mixins/myMixins'

export default {
  props: ['scp'],
  mixins: [myMixins],
  data () {
    return {
      showDatePicker: false,
      picker: new Date().toISOString().substr(0, 10)
    }
  },
  computed: {
    clients () {
      return this.$store.state.clients
    },
    vineyardAbbreviation () {
      return this.scp.Location.name.substring(0, 3)
    },
    varietalAbbreviation () {
      for (var i=0; i < this.$store.state.varietals.length; i++) {
        let varietal = this.$store.state.varietals[i]
        if (varietal.name === this.scp.varietal) {
          return this.$store.state.varietals[i].abbreviation
        }
      }
      return 'NF'
    }
  },
  methods: {
    // hasPermission () {
    //   if (this.isStaff() === true) return true
    //   console.log(JSON.stringify(this.scp, null, 2))
    //   for (var i=0; i<this.clients.length; i++) {
    //     let client = this.clients[i]
    //     if (this.scp.WorkOrder.clientCode === client.CODE) {
    //       return true
    //     }
    //   }
    //   return false
    // },
    setNewDate () {
      this.$emit('updateDateOnSCP', this.scp)
    },
    goto () {
      this.$store.state.client = this.scp.WorkOrder.Client
      this.$router.push({
        path: '/workorder',
        query: {
          id: this.scp.WorkOrder.id
        }
      })
    },
    nextDay () {
      var newDate = moment(this.scp.WorkOrder.date).add(1, 'day')
      this.scp.WorkOrder.date = newDate.toDate()
      axios
        .put(process.env.VUE_APP_BACKEND+'workorders/'+this.scp.WorkOrder.id, this.scp.WorkOrder)
        .then((response) => {
          this.$emit('scpChanged', this.scp)
        }
        )
    },
    prevDay () {
      var newDate = moment(this.scp.WorkOrder.date).subtract(1, 'day')
      this.scp.WorkOrder.date = newDate.toDate()
      axios
        .put(process.env.VUE_APP_BACKEND+'workorders/'+this.scp.WorkOrder.id, this.scp.WorkOrder)
        .then((response) => {
          this.$emit('scpChanged', this.scp)
        }
        )
    }

  }
}
</script>
<style>
</style>
